<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduces">
      <p class="sub_title">
        培训流程
      </p>
      <div class="process">
        <div class="address">
          <div class="lists">
            <div
              v-for="item in processList"
              :key="item.id"
              :class="item.id == 1 ? 'a1' : item.id == 5 ? 'a5' : ''"
              class="list"
            >
              <div class="item_list">
                <div class="img">
                  <img
                    :src="item.img"
                    alt=""
                  >
                </div>
                <div class="title">
                  {{ item.title }}
                </div>
                <div class="content">
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="introduces bg_color">
      <p class="sub_title">
        培训课程
      </p>
      <div class="lists height" />
    </div> -->
    <div class="introduces">
      <p class="sub_title">
        培训价值
      </p>
      <div class="lists">
        <div
          v-for="item in worthList"
          :key="item.id"
          class="list"
        >
          <div class="item_list">
            <div class="img">
              <img
                :src="item.img"
                alt=""
              >
            </div>
            <div class="content">
              <div
                v-for="list in item.list"
                :key="list"
              >
                {{ list }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Training',
  components: {
    banner
  },
  data() {
    return {
      title: '安全技术培训服务',
      content:
        '安全技术培训是包括等保建设、 应急响应、 安全产品、 渗透测试、 主机加固的培训。',
      worthList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training1.png'),
          list: ['提高客户的安全生产水平']
        },
        {
          id: 2,

          img: require('@/assets/securityServices/training2.png'),
          list: ['提高员工的技术知识水平']
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training3.png'),
          list: ['提高干部的安全管理业务水平']
        },
        {
          id: 4,
          img: require('@/assets/securityServices/training4.png'),
          list: ['提高员工的预防和处理安全事故的能力']
        }
      ],
      processList: [
        {
          id: 1,
          img: require('@/assets/securityServices/training5.png'),
          title: '等保建设培训',
          content: '了解等保建设的定义和思路，掌握等保建设的流程和内容。'
        },
        {
          id: 2,
          img: require('@/assets/securityServices/training6.png'),
          title: '应急响应培训',
          content: '了解应急响应的定义和重要性，掌握应急响应的流程和内容。'
        },
        {
          id: 3,
          img: require('@/assets/securityServices/training7.png'),
          title: '安全产品培训',
          content: '掌握安全产品的配置和使用方法。'
        },
        {
          id: 4,
          img: require('@/assets/securityServices/training8.png'),
          title: '渗透测试培训',
          content: '了解渗透测试的定义和意义，掌握渗透测试的流程和内容。'
        },
        {
          id: 5,
          img: require('@/assets/securityServices/training9.png'),
          title: '主机加固培训',
          content: '了解主机加固的定义和意义，掌握主机加固的流程和内容。'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.introduces {
  width: 100%;
  margin: 82px auto;

  .title {
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
  }
  .lists {
    width: 70%;
    margin: 0 auto;
    margin-top: 66px;
    display: flex;
    justify-content: space-between;

    .list {
      width: 28%;
      margin-top: 30px;
      margin: 0 1%;
      background: #fff;
      box-shadow: 0 0 50px #ddefff;

      .item_list {
        width: 100%;
        .img {
          text-align: center;
          padding-top: 88px;
          img {
            width: 175px;
            height: auto;
          }
        }
        .content {
          width: 80%;
          margin: 89px auto 133px;

          div {
            text-align: center;
            font-size: 17px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
          }
        }
      }
    }
  }
  .height {
    min-height: 500px;
  }
  .process {
    width: 70%;
    margin: 93px auto 0;
    background: linear-gradient(to top, #d7e7fc, #d7e7fc);
    padding: 80px 0;

    .address {
      width: 100%;

      .lists {
        width: 90% !important;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        .a1 {
          border-top-left-radius: 20px !important;
        }
        .a5 {
          border-top-right-radius: 20px !important;
        }
        .list {
          width: 18%;
          margin: 0 1%;
          background-color: #ffffff;
          border-radius: 4px;
          .item_list {
            width: 100%;
            .img {
              text-align: center;
              img {
                width: 90px;
                height: 90px;
              }
            }
            .title {
              text-align: center;
              font-size: 24px;
              color: #333333;
              font-weight: bold;
              margin-top: 45px;
              line-height: 40px;
            }
            .content {
              margin: 51px auto;
              width: 70%;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
}
.bg_color {
  background: #fafbff;
  padding: 95px 0;
}
@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .introduces .process .address .lists .list .item_list .title{
    font-size: 22px;
  }

}
@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .introduces .process .address .lists .list .item_list .title{
    font-size: 22px;
  }
}

</style>
